import { FC } from 'react';
import cc from 'classcat';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import './skeleton.less';
import { ProvidersSliderHeaderSkeleton } from 'newelements/Casino/Providers/__partials/ProvidersSlider/__patials/ProvidersSliderHeader/skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const SLIDER_PROVIDERS_SKELETON_ITEMS_COUNT = 30;

export const ProvidersSliderSkeleton: FC = () => {
  return (
    <div
      className={cc([
        'providersSlider providersSlider__skeleton',
        { 'providersSlider--mobile': isMobile() }
      ])}
    >
      <ProvidersSliderHeaderSkeleton />
      <div className="providersSlider__items__skeleton">
        {createArray(SLIDER_PROVIDERS_SKELETON_ITEMS_COUNT).map(i => (
          <Skeleton.Button
            active
            style={{ height: '40px', width: '120px' }}
            key={i}
          />
        ))}
      </div>
    </div>
  );
};
